import React from "react";
import styles from "./plugin.module.scss";
import { ITitlePlugin } from "../../model/plugin";
import { SildeStyleTwo } from "../slideComponent/slideStyle";
import { IBaseBox } from "../../model/base";
import { Title } from "./plugin";

interface AdSlideProps {
  title: ITitlePlugin[];
  slides: IBaseBox[];
}
export default function AdSlide(props: AdSlideProps) {
  const { title, slides } = props;
  return (
    <div className={styles["ebook-slide"]}>
      <Title data={title} />
      <SildeStyleTwo slides={slides} />
    </div>
  );
}
